import Image from "next/image";
import IMAGES from "@/public/assets/img";

export default function LapSolutions({ data }) {
  const { sectionTitle, mainHeading, image, cases } = data;

  return (
    <section className="bg-[#FFFFFF] py-12 sm:pt-0 sm:pb-12">
      <div className="max-w-4xl mx-auto px-3 flex sm:flex-col justify-between gap-4">
        <div className="w-1/2 sm:w-full">
          <p className="text-baseBlack mb-2 text-base2 font-medium sm:text-lg">
            {sectionTitle}
          </p>
          <h2 className="text-heading text-baseBlack mb-4 sm:text-xl">{mainHeading}</h2>
          <ul className="flex flex-col gap-2">
            {cases.map((item) => (
              <li
                key={item.id}
                className="flex items-center gap-1 text-gray-700 text-[22px] sm:text-lg"
              >
                <Image
                  src={IMAGES.ImportFactoring.yes}
                  width={24}
                  height={24}
                />
                <span dangerouslySetInnerHTML={{ __html: item.text }} />
              </li>
            ))}
          </ul>
        </div>
        <div className="sm:w-full">
          <Image
            src={image}
            alt="Corporate Mortgage Lending"
            width={429}
            height={300}
            className="object-contain"
          />
        </div>
      </div>
    </section>
  );
}
